var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoadingLogoBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 105 105",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0 {\n    opacity:0.6;\n    fill:#006394;\n  }\n  \n\t.st1 {\n    opacity:0.8;\n    fill:#006394;\n  }\n  \n\t.st2 {\n    fill:#006394;\n  }\n\t\n  .st3 {\n    opacity:0.6;\n  }\n  \n  #loadinglogo {\n  animation: rotatelogo 1s cubic-bezier(0.2, 0.8, 0.4, 1) infinite;\n  transform-origin: 50% 50%;\n}\n\n@keyframes rotatelogo {\n  100% {\n  transform: rotate(90deg);\n  }\n}\n  \n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "loadinglogo"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3,71.6c-0.6,0.6-0.6,1.7,0,2.3l7.8,7.8c0.6,0.6,1.7,0.6,2.3,0l19.1-19.1L22.1,52.5L3,71.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M81.7,13.1c0.6-0.6,0.6-1.7,0-2.3L73.9,3c-0.6-0.6-1.7-0.6-2.3,0L52.5,22.1l10.1,10.1L81.7,13.1z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 35.2,
    y: 35.2,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -17.546 42.3688)",
    className: "st1",
    width: 14.3,
    height: 14.3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M102,33.4c0.6-0.6,0.6-1.7,0-2.3l-7.8-7.8c-0.6-0.6-1.7-0.6-2.3,0L72.8,42.4l10.1,10.1L102,33.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23.2,91.9c-0.6,0.6-0.6,1.7,0,2.3l7.8,7.8c0.6,0.6,1.7,0.6,2.3,0l19.1-19.1L42.3,72.7L23.2,91.9z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 55.5,
    y: 55.5,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -25.9448 62.6317)",
    className: "st1",
    width: 14.3,
    height: 14.3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M71.6,102c0.6,0.6,1.7,0.6,2.3,0l7.8-7.8c0.6-0.6,0.6-1.7,0-2.3L62.6,72.8L52.5,82.9L71.6,102z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.1,23.3c-0.6-0.6-1.7-0.6-2.3,0L3,31.1c-0.6,0.6-0.6,1.7,0,2.3l19.1,19.1l10.1-10.1L13.1,23.3z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 35.2,
    y: 55.5,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -31.8771 48.3009)",
    className: "st1",
    width: 14.3,
    height: 14.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.1,
    y: 45.3,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -27.6783 38.1656)",
    className: "st2",
    width: 14.3,
    height: 14.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.1,
    y: 45.3,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -27.6783 38.1656)",
    className: "st2",
    width: 14.3,
    height: 14.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45.3,
    y: 65.6,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -36.0802 58.4333)",
    className: "st2",
    width: 14.3,
    height: 14.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45.3,
    y: 65.6,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -36.0802 58.4333)",
    className: "st2",
    width: 14.3,
    height: 14.3
  }), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M82.9,52.5L72.8,62.6l19.1,19.1c0.6,0.6,1.7,0.6,2.3,0l7.8-7.8c0.6-0.6,0.6-1.7,0-2.3L82.9,52.5z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 55.5,
    y: 35.2,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -11.6108 56.6922)",
    className: "st1",
    width: 14.3,
    height: 14.3
  }), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M33.4,3c-0.6-0.6-1.7-0.6-2.3,0l-7.8,7.8c-0.6,0.6-0.6,1.7,0,2.3l19.1,19.1l10.1-10.1L33.4,3z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 45.3,
    y: 25.1,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -7.4179 46.5616)",
    className: "st2",
    width: 14.3,
    height: 14.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45.3,
    y: 25.1,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -7.4179 46.5616)",
    className: "st2",
    width: 14.3,
    height: 14.3
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "72.8,42.4 62.6,52.5 72.8,62.6 82.9,52.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "72.8,42.4 62.6,52.5 72.8,62.6 82.9,52.5  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadingLogoBlue);
export default __webpack_public_path__ + "static/media/LoadingLogoBlue.6ffd53a92f11371acb447c7fd3e4e1f3.svg";
export { ForwardRef as ReactComponent };